// Single source of truth for all copy — hard-coded per your pick.
export const site = {
  name: 'William Ladino',
  role: 'UI Developer',
  location: 'Newcastle, AU',
  tz: 'Australia/Sydney',

  nav: [
    { id: 'about', label: '01 About me' },
    { id: 'skills', label: '02 Skills' },
    { id: 'audits', label: '03 UX Audits' },
    { id: 'passions', label: '04 Off the clock' },
    { id: 'contact', label: '05 Contact' },
  ],

  hero: {
    firstName: 'William',
    lastName: 'Ladino',
    meta: [
      { k: 'Role', v: 'UI Developer' },
      { k: 'Based', v: 'Newcastle, AU' },
      { k: 'LinkedIn', v: 'wladino', href: 'https://www.linkedin.com/in/wladino/' },
      { k: 'Reading', v: "Ask me what I'm reading" },
    ],
    tag: 'Two decades helping design and engineering teams ship work they’re both proud of',
  },

  about: {
    num: '01',
    title: 'About me.',
    meta: 'Person, place, things I do',
    body1:
      "I'm a UI developer who thinks in pixels and CSS variables. Over twenty years turning design files into production interfaces that designers actually recognise when they ship. I write framework-agnostic HTML, CSS and JavaScript — the kind that outlives the framework of the month.",
    body2:
      'Currently based in Newcastle, Australia. Working on enterprise dashboards, government portals, one very stubborn e-commerce replatform. I care about users, type, contrast, motion that earns its keep, and shipping.',
    facts: [
      'CURRENTLY · UX/UI work + front-end dev + WordPress websites',
      'STACK · HTML · CSS · JS · Power Apps · WordPress',
      'HOURS · 08–16 Sydney time',
    ],
  },

  skills: {
    num: '02',
    title: 'Skills.',
    meta: 'Seven things, practised daily',
    list: [
      { idx: '02.1', name: 'HTML', tag: 'Semantic · Accessible · Clean' },
      { idx: '02.2', name: 'CSS', tag: 'Grid · Flex · Custom layouts' },
      { idx: '02.3', name: 'JavaScript — framework agnostic', tag: 'Vanilla · React · Vue · Angular' },
      { idx: '02.4', name: 'User Interface design', tag: 'Design · Mockups · Components' },
      { idx: '02.5', name: 'User Experience design', tag: 'Flows · Research · Prototypes' },
      { idx: '02.6', name: 'Microsoft Power Apps', tag: 'Portal · Liquid · Forms · Flows' },
      { idx: '02.7', name: 'WordPress', tag: 'CMS · Custom templates · Maintenance' },
    ],
  },

  audits: {
    num: '03',
    title: 'Audit by Humans.',
    meta: 'auditbyhumans.io · Side practice · UX/UI reviews · ships in 7 days',
    pitchTitle: 'A second pair of\nhuman eyes\non your website experience.',
    pitchBody:
      "Most UX/UI reviews are half a bot readout and half a vibe check. Audit by Humans is neither. It's a written review by someone who has actually shipped interfaces, looking at yours, in your browser, with their hands.",
    pitchSmall:
      'Every audit is done by a real person — not an automated tool. Not AI. A human who understands user experience, design, web technologies, and how service businesses actually engage customers.',
    tiers: [
      {
        tier: 'Quick audit',
        price: 'A$ 149',
        featured: true,
        body: 'A Loom walkthrough with your top 5–8 issues. Perfect if you want fast feedback or are testing the waters.',
      },
      {
        tier: 'Deep audit report',
        price: 'A$ 299',
        featured: false,
        body: 'Written report covering layout, messaging, trust signals, mobile UX, and CTAs. Prioritised fix list included.',
      },
      {
        tier: 'Audit + strategy call',
        price: 'A$ 599',
        featured: false,
        body: 'Everything above, plus 30 mins where we map out your action plan together. For serious clients ready to move.',
      },
    ],
    ctaUrl: 'https://auditbyhumans.io',
  },

  passions: {
    num: '04',
    title: 'Off the clock.',
    meta: 'Força Barça · Forza Ferrari · Go the Knights · Updated live on match and race days',
    football: 'Football',
    f1: 'Formula 1',
    nrl: 'NRL',
  },

  contact: {
    num: '05',
    title: 'Say hello.',
    meta: 'Usually replies within one business day',
    headline: 'Tell me about\nthe thing.',
    details: [
      { label: 'LinkedIn: ', link: 'wladino', href: 'https://www.linkedin.com/in/wladino/' },
      'Quickest replies: Mon – Thu',
      'Audits booked 2–3 weeks ahead',
      'Sydney time · AEST / AEDT',
    ],
    projectTypes: [
      'UI/UX design',
      'Front-end fixes',
      'Full website build',
      'Quick UX audit',
      'Deep UI/UX audit report',
      'Just a chat about your project',
      'Something else',
    ],
  },

  footer: [
    `© ${new Date().getFullYear()} William Ladino`,
    'Made by a human using HTML + CSS + JS',
    'v1.0',
  ],
};
